import React from "react";
import { BPMDial } from "./BPMDial";
import { TimeSignature } from "./TimeSignature";
import { SubdivisionsSphere } from "./SubdivisionsSphere";
import { BPMSlider } from "./BPMSlider";
import { AudioSettings } from "./AudioSettings";

interface MainControlsProps {
  bpm: number;
  beatsPerBar: number;
  noteValue: number;
  subdivision: number;
  volume: number;
  reverbAmount: number;
  clickStyle: string;
  currentBeat: number;
  dialFlashingEnabled: boolean;
  stressFirstBeat: boolean;
  stressedBeats: number[];
  controlsLocked?: boolean;
  subdivisionsEnabled?: boolean;
  audioSettingsExpanded?: boolean;
  onBPMChange: (bpm: number) => void;
  onBeatsPerBarChange: (beats: number) => void;
  onNoteValueChange: (noteValue: number) => void;
  onSubdivisionChange: (subdivision: number) => void;
  onVolumeChange: (volume: number) => void;
  onReverbChange: (reverb: number) => void;
  onClickStyleChange: (style: string) => void;
  onAudioSettingsExpandedChange?: (expanded: boolean) => void;
}

export function MainControls({
  bpm,
  beatsPerBar,
  noteValue,
  subdivision,
  volume,
  reverbAmount,
  clickStyle,
  currentBeat,
  dialFlashingEnabled,
  stressFirstBeat,
  stressedBeats,
  controlsLocked,
  subdivisionsEnabled,
  audioSettingsExpanded,
  onBPMChange,
  onBeatsPerBarChange,
  onNoteValueChange,
  onSubdivisionChange,
  onVolumeChange,
  onReverbChange,
  onClickStyleChange,
  onAudioSettingsExpandedChange,
}: MainControlsProps) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "20px",
      }}
    >
      <BPMDial
        bpm={bpm}
        onBPMChange={onBPMChange}
        currentBeat={currentBeat}
        dialFlashingEnabled={dialFlashingEnabled}
        stressFirstBeat={stressFirstBeat}
        stressedBeats={stressedBeats}
        controlsLocked={!!controlsLocked}
      />

      <TimeSignature
        beatsPerBar={beatsPerBar}
        noteValue={noteValue}
        onBeatsPerBarChange={onBeatsPerBarChange}
        onNoteValueChange={onNoteValueChange}
        controlsLocked={!!controlsLocked}
      />

      {/* Subdivisions Sphere - appears when subdivisions toggle is on */}
      <div
        className={`subdivisions-sphere-container ${
          subdivisionsEnabled ? "visible" : ""
        }`}
      >
        <SubdivisionsSphere
          subdivision={subdivision}
          onSubdivisionChange={onSubdivisionChange}
        />
      </div>

      <BPMSlider
        bpm={bpm}
        onBPMChange={onBPMChange}
        controlsLocked={!!controlsLocked}
      />

      <AudioSettings
        volume={volume}
        onVolumeChange={onVolumeChange}
        reverbAmount={reverbAmount}
        onReverbChange={onReverbChange}
        clickStyle={clickStyle}
        onClickStyleChange={onClickStyleChange}
        isExpanded={audioSettingsExpanded}
        onExpandedChange={onAudioSettingsExpandedChange}
      />
    </div>
  );
}
